import React, { useState } from "react";
import EAModal from "../../shared/Modal/EAModal";
import "./RegisterB2BStyle.scss";
import { RegisterB2BModel } from "./RegisterB2BModel";
import FormPart1 from "./FormPart1";
import FormPart2 from "./FormPart2";
import { SubmitHandler, useForm } from "react-hook-form";
import { post } from "../../../api";
import { useDispatch } from "react-redux";
import { setErrors, setSuccessMessage } from "../../../store/alerts/alertsActions";
import { B2B_REGISTER } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  logo: string;
}

const RegisterB2B: React.FC<IProps> = ({ logo }: IProps) => {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const [part, setPart] = useState<1 | 2 | 3>(1);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<RegisterB2BModel>({
    defaultValues: {
      acceptRule: false,
    },
  });

  const handleRegistration: SubmitHandler<RegisterB2BModel> = async (data) => {
    if (part === 1) {
      setPart(2);
    } else if (part === 2) {
      const { isError, errorTable } = await post(B2B_REGISTER(facilityIds), data);
      if (!isError) {
        setPart(3);
        reset();
        dispatch(setSuccessMessage("Wysłaliśmy Twoją prośbę o dołączenie do partnerów"));
      } else {
        dispatch(setErrors(errorTable));
      }
    }
  };

  return (
    <EAModal isOpen hideButtons onClose={() => {}} title="" isCloseButton={false}>
      <div className="b2b-register-container">
        <div className="b2b-register-logo">
          <img src={logo} alt="Logo sklepu" />
        </div>
        <h2 className="text-centered no-margins">Zostań naszym partnerem</h2>
        <p className="text-centered">
          Jeśli otrzymałeś ten link od Park Wodny w Krakowie S.A. oznacza to, że zostałeś zaproszony do grona
          przedsiębiorców zamawiających wejściówki jako partner biznesowy.
        </p>
        <div className="b2b-register-form">
          <form onSubmit={handleSubmit(handleRegistration)}>
            {part === 1 && <FormPart1 errors={errors} register={register} />}
            {part === 2 && <FormPart2 errors={errors} register={register} control={control} />}
            {part === 3 && (
              <div className="b2b-register-form__success">
                <EAAlert type="success" message="Wysłaliśmy Twoją prośbę o dołączenie do partnerów" />
              </div>
            )}
          </form>
        </div>
      </div>
    </EAModal>
  );
};

export default RegisterB2B;
